{
  "fixers": {
    "adiGroupFixer": "MF84MWYzYWY5N2EwNzQ2ZTFmZGFlNzFiMDNkMGMxYzljZA==",
    "fiveGridLineFullWidthFixer": "MV82NGQ0MTYzNjFlOTEwMzU4YjUxNjg2YjY5MjAzM2Q1OQ==",
    "brokenAnchorsFixer": "Ml8wMWYyYzVkZTk4NDk4OGU3YWMxNjg0MzJkY2Y4OGE1NQ==",
    "brokenLoginBarFixer": "M180YzY5YmYyOTUyOWExOWUzMjJiYjFjYjc2MjRkM2NlMA==",
    "orphanSlideDataFixer": "NF82MDJmMjRlMWUwZWEzMGY2MmVlMzliODk5Yzc3YjFiZg==",
    "siteMembersDataFixer": "NV9iN2Y1YzNlZGRmNzlhNjk5MTk2MjNiMWE2NzczODEwNw==",
    "textComponentDataFixer": "Nl85OWJkMmZiZTUzMzFiNjRkMTI0ZmEyNDU5ZmVlZDRhYQ==",
    "VectorImageDataFixer": "N19hNjBmZjBiNGNlMjVhZWNlYTVhYTVmZmNjMGIxOWZhMQ==",
    "visualFocusFixer": "OF8xYTFjNjQ4MmU3NDkwOTVmZjlhM2JmMmIxOTg1NDljOQ==",
    "mobileAnimationsDataFixer": "OV83YjU5NjAxYmQ3Y2VhZWEwYzQxMDk2ZDYwN2I0Y2QzNw==",
    "stylesDataFixer": "MTBfN2U5YTIxZGI3ZTI2ODdmNWMzY2QzN2M1YTBjYTkxYmU=",
    "menuReferencesFixer": "MTFfZTVlNjcxNjdkYTBlOWFiMmFkMjEyZTBkODNlNjVlYjg=",
    "soapOrderFixer": "MTJfMzBjNDQ2OTQ2YjA0ODlhYzg1YTA3Y2ZhZmVhNzFiMjE=",
    "languageSelectorFixer": "MTNfMjVhOWZhMzdlNjQ2MWQ1NjMwMmVhMzU5ZDVmNmExMGI=",
    "meshLayoutReadySiteDataFixer": "MTRfMzUyMDBhMGEyMDA3N2E4ODMzZTlmYzVjZWM1NWExNGQ=",
    "routersDataFixer": "MTVfNGNhN2E5YjRjMDk1OWY0MjIxNGRlZWIxNWFkODA2ZDQ=",
    "sospDataFixer": "MTZfZjE4ZWYxODc1NWFlNjExZTFhZjIzY2I0OWMwNmYyNzA=",
    "menuContainerDataFixer": "MTdfOTZkOWQ4ZWZkNjBhNWM2NTc1ZjUwMzQ1YjU4M2YzMDg=",
    "addMissingPageStyleFixer": "MThfYTdhZDRjMDkyMzNjNDAzM2NiYWVhYjY0OGQ3NDQwNjg=",
    "formsControllerTypeDataFixer": "MTlfNTdhYjU3YzEyZGQzMGRjYWZjMTA5ZmVlN2IxMGY0Yzg=",
    "badPagesDataItemsDataFixer": "MjBfODMyMTJiMzUxMTExMGZlMjUzMWUyZDBiNGU5NjNlY2E=",
    "customMenuPermanentDataNodesFixer": "MjFfZjQ2ODMwNjMyZmI2MjY3ODA4NDYxYjZkNTlmNTI1MjE=",
    "duplicatedMobileHintsDataFixer": "MjJfYzIwNDliNTM3MWZmMTBlMTU1MGIxNThkMWU2NDUyN2M=",
    "hoverboxSplitOverrideFixer": "MjNfMTEzOWMxNjA1MzFmZTA2ZGZiYmQ0ZDA1NTk1MjFlYmU=",
    "duplicateDesignDataFixer": "MjRfNDQ0OTI4NTUzYWFiMjI5ZWEyZDZlZjI0YjUwZTdiM2I=",
    "pageBackgroundTranslationFixer": "MjVfMTk2NzI0OWIxMjFiMDk2NDc1NGE2ZGE5ZTM4ODA3ZjY=",
    "unknownTypeVariantsFixer": "MjZfNmFlMWIyNGRkMTI2MWQwZTZjNTE3YTU5YmUzZmE3MDE=",
    "oldBlogDeprecationFixer": "MjdfMDhlOWMxYzA4YzAxNTMxMjdiNzdhNDUzYTQyOWU1ZTY=",
    "dynamicContactFormDeprecationFixer": "MjhfZDY3ZTM3ZGNjNDg4N2Q0Y2YxOTJhOWU1YTRlODc3MmU=",
    "hoverToStateReactionFixer": "MjlfMzNlYzhhMDNmNWUzMDQ5OGU5NGFjYTEwZTc3MTRhYTM="
  },
  "lastFixerIndex": 29,
  "signature": "2ee38b811081e0b1c67c4707bd04140e"
}
